import React, { useState } from 'react'
import { CheckSquare, Smartphone, Activity, Check, Gem } from 'lucide-react'

export function DailyMissions({ onClaimReward }) {
  const [claimed, setClaimed] = useState(false)

  const handleClaim = () => {
    if (claimed) return
    setClaimed(true)
    onClaimReward?.(150, 25)
  }

  return (
    <div className="rounded-2xl bg-gradient-to-b from-[#121824] to-[#0c121c] border border-slate-800 p-4 shadow-xl space-y-3">
      {/* Header */}
      <div className="flex items-center justify-between text-xs">
        <div className="flex items-center gap-1.5 font-extrabold text-white">
          <CheckSquare size={16} className="text-cyan-400" />
          <span>Misiones Diarias</span>
        </div>
        <span className="text-[10px] text-slate-400 font-medium">Reinicia en 6h</span>
      </div>

      {/* Mission 1 */}
      <div className="p-3 rounded-xl bg-slate-900/90 border border-slate-800/80 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-emerald-950/80 border border-emerald-500/30 flex items-center justify-center text-emerald-400 shrink-0">
            <Smartphone size={16} />
          </div>
          <div>
            <div className="flex items-center gap-1 text-xs font-bold text-white">
              <span>Rompe el Algoritmo</span>
              <Check size={12} className="text-emerald-400" />
            </div>
            <div className="text-[10px] text-slate-400">0 redes sociales en sesión</div>
          </div>
        </div>

        <button
          type="button"
          onClick={handleClaim}
          disabled={claimed}
          className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all shadow-md cursor-pointer ${
            claimed
              ? 'bg-slate-800 text-slate-500 cursor-default'
              : 'bg-emerald-500 hover:bg-emerald-400 text-slate-950 shadow-emerald-500/20 active:scale-95'
          }`}
        >
          {claimed ? 'Reclamado' : 'Reclamar'}
        </button>
      </div>

      {/* Mission 2 */}
      <div className="p-3 rounded-xl bg-slate-900/90 border border-slate-800/80 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2.5 flex-1">
          <div className="w-8 h-8 rounded-lg bg-purple-950/80 border border-purple-500/30 flex items-center justify-center text-purple-400 shrink-0">
            <Activity size={16} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-xs font-bold text-white">Doble Impacto Relámpago</div>
            <div className="w-full h-1.5 rounded-full bg-slate-800 mt-1 overflow-hidden">
              <div className="w-1/2 h-full rounded-full bg-purple-500" />
            </div>
          </div>
        </div>

        <div className="flex items-center gap-1 px-2 py-1 rounded-md bg-purple-950/80 border border-purple-500/40 text-purple-300 text-[10px] font-bold shrink-0">
          <Gem size={11} className="text-purple-400" />
          <span>+50</span>
        </div>
      </div>
    </div>
  )
}
